import { init, RematchDispatch, RematchRootState, RematchStore } from '@rematch/core';
import thunk from 'redux-thunk';
import { connectRouter, routerMiddleware } from 'connected-react-router';
import { RootModel, models } from './models';
import history from './history';

const router = routerMiddleware(history);
const middlewares = [router, thunk];

export const store = init({
  models,
  redux: {
    reducers: {
      router: connectRouter(history),
    },
    devtoolOptions: {
      realtime: true,
      name: 'Clik Virtual Tour Admin',
    },
    middlewares,
  },
});

export type Store = RematchStore<RootModel>;
export type Dispatch = RematchDispatch<RootModel>;
export type RootState = RematchRootState<RootModel>;
